
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.474 0H6.526a4.927 4.927 0 00-4.922 4.922v41.194A4.91 4.91 0 003.21 49.75v4.61c0 .906.734 1.641 1.64 1.641h46.3a1.64 1.64 0 001.64-1.64v-4.61a4.91 4.91 0 001.605-3.634V4.922A4.927 4.927 0 0049.474 0zM4.886 4.922c0-.905.736-1.64 1.64-1.64H24.18v9.491H4.886V4.922zm44.623 47.797H6.491v-1.682l.035.001H49.51v1.68zm1.605-6.603c0 .905-.736 1.641-1.64 1.641H6.526c-.904 0-1.64-.736-1.64-1.64V16.053h46.228v30.062zm0-33.343H24.18V3.281h25.294c.904 0 1.64.736 1.64 1.64v7.852z","fill":"#6C7177"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 21.6a2 2 0 012-2h24a2 2 0 012 2v19.8a2 2 0 01-2 2H16a2 2 0 01-2-2V21.6zm2.8 1.8a1 1 0 011-1h20.4a1 1 0 011 1v3.2H16.8v-3.2zm0 6v10.2a1 1 0 001 1h20.4a1 1 0 001-1V29.4H16.8z","fill":"#6C7177"}}),_c('path',{attrs:{"d":"M16.454 5.6h-2.108c-.964 0-1.746 1.254-1.746 2.8 0 1.546.782 2.8 1.746 2.8h2.108c.964 0 1.746-1.254 1.746-2.8 0-1.546-.782-2.8-1.746-2.8zM24.854 5.6h-2.108C21.782 5.6 21 6.854 21 8.4c0 1.546.782 2.8 1.746 2.8h2.108c.964 0 1.746-1.254 1.746-2.8 0-1.546-.782-2.8-1.746-2.8zM33.254 5.6h-2.108c-.964 0-1.746 1.254-1.746 2.8 0 1.546.782 2.8 1.746 2.8h2.108C34.218 11.2 35 9.946 35 8.4c0-1.546-.782-2.8-1.746-2.8zM41.654 5.6h-2.108c-.964 0-1.746 1.254-1.746 2.8 0 1.546.782 2.8 1.746 2.8h2.108c.965 0 1.746-1.254 1.746-2.8 0-1.546-.781-2.8-1.746-2.8z","fill":"#6C7177"}})])
          )
        }
      }
    